import React from 'react';

import CoinIcon from '../../../assets/images/CoinIcon.png';

import { useAuthState } from '../../../contexts/Auth/context';

// eslint-disable-next-line
const UserCoinsContainer = ({ openSignUpModal }) => {
  const {
    accountInfo: { coins },
    isLoggedIn,
  } = useAuthState();

  let textContent;
  if (isLoggedIn) {
    textContent = <span className="heading-small">You have {coins} Coins</span>;
  } else {
    textContent = (
      <span>
        <span className="cursor-pointer text-gatsby" onClick={openSignUpModal}>
          Sign up for a Paperless Post account
        </span>{' '}
        and you&apos;ll get free Coins to start sending.
      </span>
    );
  }

  return (
    <>
      <div className="w-full h-28"></div>
      <div
        className={`flex fixed md:absolute justify-center shadow-lg items-center p-6 bottom-0 left-0 right-0 bg-panna-cotta shadow-[0_0_9px_2px_rgba(0,0,0,0.25)]`}
      >
        <img alt="coin icon" className="w-7 h-7 mr-4" src={CoinIcon} />
        {textContent}
      </div>
    </>
  );
};

export default UserCoinsContainer;
